import axios from 'axios';
import config from '../../config';

import tokenApi from './tokenApi';

const groupInstance = axios.create({
	baseURL: config.api,
    headers: {
		'Content-Type': 'application/json'
	}
});

class GroupApi {  

	static GroupInsert(payload) {
		groupInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return groupInstance.post('/group', payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static GroupUpdate(payload, id) {
		groupInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return groupInstance.patch(`/group/${id}`, payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static GroupList() {
		groupInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return groupInstance.get('/group?showPassword=true')
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static GroupDelete(id) {
		groupInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return groupInstance.delete(`/group/${id}`)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

}

export default GroupApi; 


